<template>
    <div>
        <!-- REGISTRO SOLICITUDES-->
        <v-card class="mx-auto" style="margin-top:1rem">
            <v-system-bar color="#1973a5" dark>
                <v-flex class="m-4">
                    <center>CAMBIO DE TURNO</center>
                </v-flex>
            </v-system-bar>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-row class="mt-4 container">

                    <v-col cols="12" sm="12" md="6">
                        <v-autocomplete v-model="editedItem.paciente" :items="itemsDatosPaciente"
                            item-text="nombreCompleto" item-value="paciente_id" dense label="PACIENTE NOMBRE"
                            @change="updatePaciente"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-autocomplete v-model="editedItem.paciente" :items="itemsDatosPaciente" item-text="dni"
                            item-value="paciente_id" dense label="DNI" @change="updatePaciente"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-text-field v-model="editedItem.frecuenciaActual" :items="itemsFrecuencia" dense
                            label="Frecuencia Actual" disabled></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                        <v-text-field v-model="editedItem.turnoActual" :items="itemsTurno" dense label="Turno Actual"
                            disabled></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                        <v-select v-model="editedItem.nuevoTurno" :items="itemsNuevoTurno" @change="updateNumPuesto"
                            :rules="[rules.required]" dense label="Nuevo Turno"></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                        <v-select v-model="editedItem.nuevoPuesto" :items="itemsNuevoPuesto" @change="clinicaFinal"
                            :rules="[rules.required]" dense label="Número Puesto"></v-select>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
                    <v-btn color="blue darken-1" text @click="save"> Guardar </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-dialog v-model="dialogLoad" hide-overlay persistent width="300" class="fondo-griss">
            <v-card color="primary" dark>
                <v-card-text>
                    Cargando Datos
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<style>
.v-dialog__content--active {
    background: #59595940;
    backdrop-filter: blur(1px);
}

.v-system-bar.theme--dark {
    padding: 1rem;
    color: white;
}
</style>
<script>
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import axios from "axios";
import Swal from "sweetalert2";

export default {
    data: () => ({
        itemsClinicaFinal: null,
        dialogLoad: false,
        nombrePaciente: [],
        editedItem: {
            paciente: "",
            frecuencia: "",
            frecuenciaActual: "",
            turnoActual: "",
            nombrePaciente: "",
            correo: "",
            nuevoTurno: "",
            nuevoPuesto: "",
            tipoPuestoActual: "",
            idAsisCupo: ""
        },
        headers: [],
        desserts: [],
        dialog: false,
        valid: true,
        rules: {
            required: (value) => !!value || "Campo Obligatorio.",
            email: (value) => !!/\w+@\w+\.+[a-z]/.test(value) || "Correo invalido",
        },
        itemsDatosPaciente: [],
        itemsTurno: [],
        itemsFrecuencia: [],
        itemsTipoPuesto: [],
        itemsNumeroPuesto: [],
        itemsNuevoPuesto: [],
        itemsNuevoTurno: [],
        nombrePaciente: "",
        correo: "",
    }),
    methods: {
        updatePaciente() {
            this.editedItem.frecuenciaActual = "";
            this.editedItem.turnoActual = "";
            this.editedItem.nuevoTurno = "";
            this.editedItem.nuevoPuesto = "";
            this.itemsNuevoTurno = [];
            this.itemsNuevoPuesto = [];
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API + "/generar_turno_actual/", { paciente_id: this.editedItem.paciente },
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {
                            if (res.data[0].frecuencia || res.data[0].tipoPuesto)
                                this.editedItem.frecuenciaActual = res.data[0].frecuencia;
                            this.editedItem.tipoPuestoActual = res.data[0].tipoPuesto;
                            this.editedItem.idAsisCupo = res.data[0].asigCupoId;
                            this.editedItem.turnoActual = res.data[0].turno;
                            this.buscarCuposClinica(res.data[0].casId);
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        updateNumPuesto() {
            this.itemsNuevoPuesto = [];
            const numeroPuesto = this.desserts.filter(
                (e) =>
                    e.turno == this.editedItem.nuevoTurno &&
                    e.frecuencia == this.editedItem.frecuenciaActual &&
                    e.tipoPuesto == this.editedItem.tipoPuestoActual
            ).sort((a, b) => a.numeroPuesto - b.numeroPuesto);
            for (let i = 0; i < numeroPuesto.length; i++) {
                const element = numeroPuesto[i];
                this.itemsNuevoPuesto.push(element.numeroPuesto);
            }
        },
        clinicaFinal() {
            this.itemsClinicaFinal = this.desserts.filter(
                (e) =>
                    e.turno == this.editedItem.nuevoTurno &&
                    e.frecuencia == this.editedItem.frecuenciaActual &&
                    e.tipoPuesto == this.editedItem.tipoPuestoActual &&
                    e.numeroPuesto == this.editedItem.nuevoPuesto
            );
            console.log("clinica datos parametrocentro", this.itemsClinicaFinal)
        },
        listarPacientes() {
            this.dialogLoad = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API + "/generar_lista_pacientes/",
                            {
                                clinica_id: null
                            },
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {
                            this.itemsDatosPaciente = [];
                            for (let i = 0; i < res.data.length; i++) {
                                this.itemsDatosPaciente.push({

                                    nombreCompleto: res.data[i].nombreCompleto,
                                    dni: res.data[i].dni,
                                    paciente_id: res.data[i].paciente_id,
                                });
                            }
                            this.dialogLoad = false;
                        })
                        .catch((res) => {
                            console.warn("Error:", res);
                            this.dialog = false;
                            this.dialogLoad = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        buscarCuposClinica(item) {
            this.dialogLoad = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API +
                            "/generar_lista_disponible/", { clinica_id: item },
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {
                            this.dialogLoad = false;
                            this.desserts = res.data;
                            for (let i = 0; i < this.desserts.length; i++) {
                                this.itemsFrecuencia.push(this.desserts[i].frecuencia);
                                if (this.editedItem.frecuenciaActual === this.desserts[i].frecuencia && this.editedItem.tipoPuestoActual === this.desserts[i].tipoPuesto && this.editedItem.turnoActual !== this.desserts[i].turno) {
                                    this.itemsTurno.push(this.desserts[i].turno);
                                    this.itemsNuevoTurno.push(this.desserts[i].turno);
                                }
                            };
                            if (this.itemsTurno.length == 0) {
                                Swal.fire({
                                    title: "Error!",
                                    text: "El paciente no tiene turno disponible para la frecuencia actual en la que se encuentra.",
                                    confirmButtonText: "Aceptar",
                                    customClass: {
                                        popup: 'custom-swal-modal',
                                        icon: 'mobile-error-icon'
                                    }
                                });
                            }
                            const uniqueItems = [...new Set(this.itemsNuevoTurno)];

                            // Ordenar de forma ascendente
                            uniqueItems.sort();
                            uniqueItems.sort((a, b) => {
                                const turnoA = parseInt(a.split(" ")[1]); // Extraer el número del turno
                                const turnoB = parseInt(b.split(" ")[1]);
                                return turnoA - turnoB;
                            });
                            this.itemsNuevoTurno = uniqueItems;
                        })
                        .catch((res) => {
                            console.log("SSSSS", res.data);
                        });
                });
        },
        close() {
            this.editedItem.paciente = "";
            this.editedItem.frecuencia = "";
            this.editedItem.frecuenciaActual = "";
            this.editedItem.turnoActual = "";
            this.editedItem.nombrePaciente = "";
            this.editedItem.correo = "";
            this.editedItem.nuevoTurno = "";
            this.editedItem.nuevoPuesto = "";
            this.editedItem.tipoPuestoActual = "";
            this.editedItem.idAsisCupo = "";
        },
        save() {
            this.clinicaFinal();
            if (this.itemsClinicaFinal.length == 0) {
                Swal.fire({
                    title: "Error!",
                    text: "¡Debe completar todos los campos!",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                });
                return;
            }
            /* console.log("prueba",`${this.usuario}|${this.nombre}`);
            return; */
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API + "/generar_movimiento_paciente/",
                            {
                                id_asignacioncupo: this.editedItem.idAsisCupo,
                                tipo_movimiento: "CAMBIO TURNO",
                                id_parameCentroPuesto: this.itemsClinicaFinal[0].id_ParametroCentro,
                                usuario: `${this.usuario}|${this.nombre}`,
                                fecha: new Date().toISOString().substr(0, 10),
                                cas: null
                            },
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: `${res.data[0].f}`,
                                icon: "success",
                                confirmButtonText: "Aceptar",
                            });
                            this.close();
                        })
                        .catch((res) => {
                            console.log("Error1:", res);
                            this.dialogDataApi = false;
                            Swal.fire({
                                title: "Error!",
                                text: "¡El registro no se completó!",
                                icon: "error",
                                confirmButtonText: "Aceptar",
                            });
                            this.close();
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() {
        if (!sessionStorage.getItem("keyValue")) {
            this.$router.push("/");
        }
    },
    created() {
        this.perfil = sessionStorage.getItem("perfil");
        this.nombre = sessionStorage.getItem("nombre");
        this.url = sessionStorage.getItem("url");
        this.usuario = sessionStorage.getItem("usuario");
        this.urlCas = sessionStorage.getItem("urlCas");
        //INICIO DE CONSULTA
        this.listarPacientes();
    },
    components: {

    },
};
</script>